<template>
    <div class="flex-grow min-h-full">


        <div class="bg-image">
            <div class="section container px-6 py-20 md:py-40 mx-auto">
                <div class="items-center lg:flex">
                    <div class="w-full flex flex-col jusctify-center text-center">
                        <!-- <h1 class="text-5xl text-theme-blue font-semibold">Novedades</h1> -->
                        <!-- <h1 class="text-5xl text-theme-blue font-semibold">{{title}}</h1>
                        <h4 class="text-gray-900 text-xl w-11/12 md:w-9/12 m-auto text-center font-normal py-6">{{subtitle}}</h4> -->
                    </div>
                </div>
            </div>
        </div>
         
        <div v-if="loading" class="flex justify-center items-center bg-gray-50 fixed w-full h-screen top-0"> 
            <div class="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-theme-sky"></div>
        </div> 

        <div v-else  class="bg-white section container mx-auto -mt-20 rounded-xl md:-mt-24  md:rounded-2xl w-11/12 md:w-8/12 shadow ">
            <div class="px-6 py-10 mb-6 w-11/12 mx-auto ">
                <div class="col-span-7">   
                    <div class="mb-6 md:mb-14 md:flex md:flex-row md:items-center text-xl">
                        <h3 class="text-3xl mb-5 md:mb-0 md:text-5xl text-theme-blue font-semibold">{{post.title}}</h3>
                        <span v-if="post.category" class="uppercase text-theme-sky text-base bg-gray-100 py-2 px-3 rounded-xl mt-14  md:mt-0 md:ml-8">{{ post.category.name }}</span>  
                    </div> 
                    
                    <div v-if="post.image">
                        <img :src="baseUrl + post.image" class="w-full rounded-2xl mb-8">
                    </div>

                    <div class="mt-3 mb-6 flex flex-col gap-4 md:gap-0 md:flex-row md:tems-center text-xl">
                        <div class="flex items-center">
                            <MapPinIcon class="w-7 h-7 mr-2 text-theme-sky"/>
                            <a v-if="post.library && post.library.location" class="hover:underline" target="_blank" :href="post.library.location">
                                {{ post.library.name }} </a>
                                <span v-else >{{ post.library.name }}</span>                            
                        </div>
                        <div class="flex text-xl items-center md:ml-4"> 
                            <CalendarDaysIcon class="w-7 h-7 mr-2 text-theme-sky"/>
                            <div>{{ post.date_evento }}</div>
                        </div>
                    </div>                    
                    <div v-html="post.content"
                         class="text-gray-600 mt-4 mb-6 font-ptserif text-lg text-justify leading-10">
                    </div>    

                </div> 
                <div @click="goBack" class="cursor-pointer w-28  bg-theme-sky text-white text-sm rounded-lg py-2 px-4 flex items-center mr-4 hover:bg-theme-blue">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" /></svg>
                    ATRAS
                  </div>
            </div>
        </div> 

    </div>  
</template>

<script>

import { MapPinIcon, CalendarDaysIcon } from '@heroicons/vue/20/solid'

export default {
    name: "NewsDetail",
    components: {
            MapPinIcon,
            CalendarDaysIcon
    },   
    data(){
        return{
            loading: false,
            post:null,
            baseUrl: process.env.VUE_APP_URL_CULTURAPP + 'storage/',
        }
    },

    methods: {
        async getPost() {
            this.loading = true;
            try {
                const response = await fetch(`${process.env.VUE_APP_URL_CULTURAPP}api/novedades/${this.$route.params.slug}`, { method: 'GET' });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                this.post = await response.json();
                this.loading = false;

            } catch (error) {
                console.error('Error fetching post:', error);
                // Manejo de errores
                this.loading = false;
            }
            
            
        },
        goBack(){
            this.$router.go(-1)
        }
    },
    created(){
        window.scrollTo(0, 0)
        this.getPost()
    }   
}
</script>

<style>

.bg-image {
  background-image: url('~@/assets/images/pluma.jpg');
  background-size: cover;
  background-position: center bottom;
}

</style>